import React from 'react'
import FileViewer from '@vivianhealth/react-file-viewer';
// import logger from 'logging-library';

export default function DocViewer({onClose, fileData}) {

  const getExtention = (url) => {
    return /[^.]+$/.exec(url); 
  }
  const onError = (e) => {
    // logger.logError(e, 'error in file-viewer');
  }

  return (
    <>
        {fileData !== null && <div className="fixed animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg-dark z-20 shadow-md md:px-8 px-4 top-0">
            <div className="relative w-full flex h-full justify-center items-center">
                <div className="">
                  <FileViewer
                    fileType={getExtention(fileData.url)}
                    filePath={fileData.url}
                    errorComponent={FiledLoaderError}
                    onError={onError} />
                </div>
            </div>
              <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-red-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
                </svg>
            </button>
        </div>}
    </>
  )
}

function FiledLoaderError () {
  return (
    <div className="text-center text-xs font-semibold text-red-800">
      <h4>Failed to load document!</h4>
    </div>
  )
}
